import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Mining from './pages/Mining'
import Energy from './pages/Energy'
import Commodities from './pages/Commodities'
import Partnerships from './pages/Partnerships'
import Contact from './pages/Contact'

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-off-white text-charcoal">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/units/mining" element={<Mining />} />
          <Route path="/units/energy" element={<Energy />} />
          <Route path="/units/commodities" element={<Commodities />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
